import styled from "styled-components";

export const ServicesContainer = styled.div`
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* margin-top: -7rem; */
  border: 10px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #743ad5, #d53a9d);
  @media screen and (max-width: 768px) {
    height: auto;
  }

  @media screen and (max-width: 480px) {
    height: auto;
  }
`;

export const Bg = styled.div`
  text-align: center;
  background-image: url("whitepaperimg.png");
  background-color: black;
  min-width: 100%;
  min-height: 100%;
  /* border-bottom: 5px solid #828; */
  /* margin-top: 7rem; */
  background-size: cover;
  height: 837px;
  background-position: center;
  @media screen and (max-width: 768px) {
    height: 544px;
  }
  @media screen and (max-width: 420px) {
    height: 746px;
  }
`;

export const Container1 = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: 100%;
  @media screen and (max-width: 420px) {
   flex-direction: column;
  }
`;
export const Container = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
`;
export const Heading = styled.h1`
 font-size: 3vw;
 margin-bottom: 0rem !important;
  /* line-height: 10px; */
  /* margin-bottom: 0.7em !important; */
  /* margin-top: 8px; */
  font-family: "hello";
  display: flex;
  justify-content: center;
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 3vw;
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

export const Subheading = styled.p`
  margin-bottom: 0px !important;
  font-size: 1.2vw;
  padding: 0.5rem;
  /* line-height: 28px; */
  text-align: center;
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 1.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
  @media screen and (max-width: 420px) {
    font-size: 2.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
`;

export const Subheading2 = styled.p`
  margin-bottom: 0px !important;
  font-size: 1.2vw;
  padding: 0.5rem;
  /* line-height: 28px; */
  text-align: left;
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 1.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
  @media screen and (max-width: 420px) {
    font-size: 2.3vw;
  }
`;

export const Bullets = styled.p`
  margin-bottom: 0px !important;
  font-size: 1.2vw;
  padding: 1rem;
  /* line-height: 28px; */
  text-align: left;
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 1.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
  @media screen and (max-width: 420px) {
    font-size: 2.3vw;
  }
`;
